"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dialog_1 = require("./lib/services/generic/dialog");
exports.Dialog = dialog_1.default;
var HandsFree_1 = require("./lib/services/generic/HandsFree");
exports.HandsFree = HandsFree_1.default;
var Sounds_1 = require("./lib/services/generic/Sounds");
exports.Sounds = Sounds_1.default;
var location_1 = require("./lib/services/navigation/location");
exports.Location = location_1.default;
var UserProfile_1 = require("./lib/services/user/UserProfile");
exports.UserAgent = UserProfile_1.default;
var Geolocation_1 = require("./lib/services/geolocation/Geolocation");
exports.Geolocation = Geolocation_1.default;
var Vis_1 = require("./lib/services/vis/Vis");
exports.VIS = Vis_1.default;
var Keyboard_1 = require("./lib/services/keyboard/Keyboard");
exports.Keyboard = Keyboard_1.default;
var Notifications_1 = require("./lib/services/notifications/Notifications");
exports.Notifications = Notifications_1.default;
var IpApp_1 = require("./lib/services/generic/IpApp");
exports.IpApp = IpApp_1.default;
var Themes_1 = require("./lib/systems/Themes");
exports.Themes = Themes_1.default;
//# sourceMappingURL=index.js.map